// @ts-nocheck
/// <reference path="../../../../../rcwebmodels/TripDetails.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import moment from 'moment';
import { RCUtils } from './../../RCUtils';
import forEach from 'lodash/forEach';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridToolBarPopups } from '../sharedcomponents/GridToolBarPopups';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import * as Exceljs from '../../actions/ExportToExcel.js';
import * as Autosuggest from 'react-autosuggest';
import { AgGridReact } from 'ag-grid-react';
import DateFormat from 'dateformat';
import Formatters from '../../actions/Formatters';
// pull in the ag-grid styles we're interested in
import './../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import './../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import './../../../node_modules/react-datepicker/dist/react-datepicker.css';
import { EditTrip } from '../childcomponents/EditTrip';
import animatedloader from '../../images/animated-loader.gif';
import deletepng from '../../images/delete.png';
import edit18 from '../../images/Status/RouteDeviation/edit_18_dis.png';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer';
var Excel = Exceljs.default;
var Config: any = require('../../Config.json');


interface TripStatusSettingsState {
    SelectedReefers: any[];
    SelectedOption: string;
    refTripDefinition: server.RefTripDefinition[];
    refTripStatus: server.RefTripStatus[];
    ModelNumber: string;
    RowData: server.SearchTripDetails_Result[];
    Filters: server.SearchTripParameters;
    SelectedReefer: string;
    TripGeofencesDetails: server.TripGeofencesDetails;
    DeleteMessage: string;
    DeleteParams: any;
    DeleteYes: boolean;
    EditTripGeofencesDetails: server.EditTripGeofencesDetails;
    DeleteTripParameters: server.DeleteTripParameters;
    pageSize: any;
    gridApiParams: any;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    suggestionsFenceId: any[];
    destSuggestionsFenceId: any[]
    RefGeofences: string[];
    targetId: string
}
var newTripGeofencesDetails: server.TripGeofencesDetails = {
    reeferID: null, TripDefinitionSelectedValue: null, unitMasetrId: null, OriginGeofence: '', DestinationGeofence: '', TripName: '',
    SFrmDate: new Date(), SToDate: new Date(), CommandUnits: []
};
var newEditTripGeofencesDetails: server.EditTripGeofencesDetails = {
    reeferID: null, TripDefinitionSelectedValue: null, unitMasetrId: null, OriginGeofence: '', DestinationGeofence: '', TripName: '',
    SFrmDate: new Date(), SToDate: new Date(), CommandUnits: [], TripId: 0, TripStatusCd: '', TripStatusDsc: ''
};
var newDeleteTripParameters: server.DeleteTripParameters = { TripId: 0, TripStatusDsc: '', CommandUnits: [] };
var colDefs;
var self;
var deleteYes;
var deleteEvent;
var ExcelcolDefs;
export class TripStatus extends React.Component<any, TripStatusSettingsState> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        self = this;
        colDefs = this.createColumnDefs();
        ExcelcolDefs = this.createExcelColumnDefs();
        var filterSet = this.setDefaultFilters();
        this.state = {
            SelectedReefers: [], refTripDefinition: [], refTripStatus: [], ModelNumber: "", RowData: [], Filters: filterSet, SelectedOption: 'show', SelectedReefer: '', TripGeofencesDetails: newTripGeofencesDetails, DeleteMessage: 'Do you want to delete the trip?', DeleteParams: null, DeleteYes: false, EditTripGeofencesDetails: newEditTripGeofencesDetails, DeleteTripParameters: newDeleteTripParameters
            , pageSize: 25
            , gridApiParams: []
            , IsCommandIssued: false, PrevSelectedItems: [], suggestionsFenceId: [], destSuggestionsFenceId: [], RefGeofences: [], targetId: ''
        };

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/GetGeofencesForTrip')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.length > 0) {
                    var fenceData = data.map(fence => fence.Address);
                    this.setState({ RefGeofences: fenceData.filter((x, i, a) => a.indexOf(x) == i) });
                }
            });
    }

    setDefaultFilters() {
        var filters: server.SearchTripParameters = {
            UnitMasetrId: null, TripDefId: "-1", TripName: null, SFrmDate: DateFormat(new Date(), 'mm/dd/yyyy HH:MM'), SToDate: DateFormat(new Date(), 'mm/dd/yyyy HH:MM'), TripStatusDsc: null, SearchType: 'show', SourceGofenceAddress: '', DestGofenceAddress: ''
        };
        return filters;
    }

    componentDidMount() {
        if (this.props.reeferData != undefined && this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ SelectedReefers: this.props.reeferData, SelectedReefer: this.props.reeferData[0].ReeferID });
            // this.bindTripData(this.state.SelectedOption, this.props.reeferData);
            this.setState({ SelectedOption: 'show' });
            this.GetTripsData("show", this.props.reeferData);
        }
        $("#inlineRadio1").prop("checked", true);
        this.HideGeofenceAndTrip('TripDefiniton');
        $('#tripLoader').hide();
        $('#ShowPending').addClass('active');
        $('#ShowAll').removeClass('active');
        $('#ShowSpecific').removeClass('active');





        // To make the Modal popups draggable.
        Excel.draggableModalPopup(document.getElementById("deleteModal"));
    }

    onGridReady(params: any) {
        //this.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true));
        //this.gridApi.sizeColumnsToFit();
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
    }

    createColumnDefs() {
        return [
            { headerName: "Edit", field: "TripId", width: 50, cellRenderer: this.EditIndicator, onCellClicked: this.onCellClickedEdit.bind(this) },
            { headerName: "Remove", field: "TripId", width: 50, cellRenderer: this.DeleteIndicator, onCellClicked: this.onCellClickedDelete.bind(this) },
            { headerName: "Trip", field: "TripStatusCdAndDFlag", tooltipField: "TripStatusDsc", width: 50, cellRenderer: ReeferCellRenderer.TripstatusIndicator },
            { headerName: "Trip name", field: "TripNm", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "Earliest departure", field: "EarliestDepartureDtm", width: 150, cellRenderer: Formatters.dateTypeFormatter12H },
            { headerName: "Arrival", field: "ArrivalDtm", width: 150, cellRenderer: Formatters.dateTypeFormatter12H },
            { headerName: "Trip Definition", field: "TripDefNm", width: 150, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "Origin", field: "SourceGofenceAddress", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 100 },
            { headerName: "Destination", field: "DestGofenceAddress", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
        ];
    }

    createExcelColumnDefs() {
        return [
            { headerName: "Trip", field: "TripStatusCdAndDFlag", tooltipField: "TripStatusDsc", width: 50, cellRenderer: ReeferCellRenderer.TripstatusIndicator },
            { headerName: "Trip name", field: "TripNm", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "Earliest departure", field: "EarliestDepartureDtm", width: 150, cellRenderer: Formatters.dateTypeFormatterforExcel },
            { headerName: "Arrival", field: "ArrivalDtm", width: 150, cellRenderer: Formatters.dateTypeFormatterforExcel },
            { headerName: "Trip definition", field: "TripDefNm", width: 150, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "Origin", field: "SourceGofenceAddress", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 100 },
            { headerName: "Destination", field: "DestGofenceAddress", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
        ];
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            this.setState({ RowData: [], SelectedReefers: reeferData, SelectedReefer: reeferData[0].ReeferID });
            //this.bindTripData(this.state.SelectedOption, reeferData);
            this.setState({ SelectedOption: 'show' });
            this.GetTripsData("show", reeferData);
            $('#ShowPending').addClass('active');
            $('#ShowAll').removeClass('active');
            $('#ShowSpecific').removeClass('active');
        }
    }

    setForwardCommandUnits() {
        var userId = 0;
        var commandUnits = [];
        if (this.state.SelectedReefers.length > 0) {
            forEach(this.state.SelectedReefers, function (value, key) {
                var commandUnitObject = {
                    "RcdEventID": value.RCDEventID,
                    "RCDMasterID": value.RCDMasterID,
                    "RcdId": value.RCDID,
                    "ReeferID": value.ReeferID,
                    "UnitControlEventID": value.UnitControlEventID,
                    "UnitEventID": value.UnitEventID,
                    "UnitMasterID": value.UnitMasterID,
                    "ParentEventId": (value.ParentEventID.HasValue) ? value.ParentEventID.Value : 0,
                    "UserId": userId,
                    "TripId": value.TripId
                };

                commandUnits.push(commandUnitObject);
            });
        }
        else {
            alert('Please select at least one record to proceed.');
        }

        return commandUnits;
    }

    DateTypeFormatter(params: any) {
        if (params != null && params != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
    }

    onCellClickedEdit(event) {
        if (event.data.TripStatusCd.toUpperCase().trim() == "P") {
            var fCommends = this.setForwardCommandUnits();
            var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
            tripGeofencesDetails.TripName = event.data.TripNm;
            tripGeofencesDetails.TripDefinitionSelectedValue = event.data.TripDefId;
            tripGeofencesDetails.SFrmDate = (event.data.EarliestDepartureDtm != null) ? this.DateTypeFormatter(event.data.EarliestDepartureDtm) : null;
            tripGeofencesDetails.SToDate = (event.data.ArrivalDtm != null) ? this.DateTypeFormatter(event.data.ArrivalDtm) : null;
            tripGeofencesDetails.OriginGeofence = event.data.SourceGofenceAddress;
            tripGeofencesDetails.DestinationGeofence = event.data.DestGofenceAddress;
            tripGeofencesDetails.reeferID = event.data.ReeferId;
            tripGeofencesDetails.unitMasetrId = this.state.SelectedReefers[0].UnitMasterID;
            tripGeofencesDetails.CommandUnits = fCommends;
            tripGeofencesDetails.TripId = event.data.TripId;
            this.setState({ TripGeofencesDetails: tripGeofencesDetails });
            $('#TripStatus').css('opacity', .5);
            $('#EditTrip').show();
            this.onRefreshData.bind(this)
            // this.props.refreshStatusGrid();
        }
    }

    onCellClickedDelete(event) {
        if (event.data.TripStatusCd.toUpperCase().trim() == "A" || event.data.TripStatusCd.toUpperCase().trim() == "P" || event.data.TripStatusCd.toUpperCase().trim() == "D") {
            deleteEvent = null;
            this.setState({ DeleteParams: event });
            deleteEvent = event;
            $('#TripStatus').css('opacity', .5);
            $("#deleteModal").css("padding-top", "100px");
            self.setDeleteMessage(event);
            $('#deleteModal').show();
            //this.props.refreshStatusGrid();
        }
    }

    onRefreshData() {
        $('#globalLoader').show();
        this.GetTripsData(this.state.SelectedOption, this.state.SelectedReefers);
        $('#globalLoader').hide();
    }
    DeleteIndicator(params: any) {
        if (params.data.TripStatusCd.toUpperCase().trim() == "A" || params.data.TripStatusCd.toUpperCase().trim() == "P" || params.data.TripStatusCd.toUpperCase().trim() == "D")
            return <span className="Trip-delete"><img src={deletepng} title='Delete Trip'></img></span>;
        else
            return <span className="Trip-delete disabled"><img src={deletepng} title='Delete Trip'></img></span>;
    }
    //DeleteIndicator(params: any) {
    //    var element = document.createElement("span");
    //    if (params.data.TripStatusCd.toUpperCase().trim() == "A" || params.data.TripStatusCd.toUpperCase().trim() == "P" || params.data.TripStatusCd.toUpperCase().trim() == "D")
    //        element.className = "Trip-delete";
    //    else
    //        element.className = "Trip-delete disabled";
    //    var imageElement = document.createElement("img");
    //    imageElement.src = deletepng;
    //    imageElement.title = "Delete Trip";
    //    element.appendChild(imageElement);
    //    return element;
    //}
    EditIndicator(params: any) {
        if (params.data.TripStatusCd.toUpperCase().trim() == "P")
            return <span className="Trip-edit"><img src={edit18} title='Edit Trip'></img></span>;
        else
            return <span className="Trip-edit disabled"><img src={edit18} title='Edit Trip'></img></span>;
    }
    //EditIndicator(params: any) {
    //    var element = document.createElement("span");
    //    if (params.data.TripStatusCd.toUpperCase().trim() == "P")
    //        element.className = "Trip-edit";
    //    else
    //        element.className = "Trip-edit disabled";
    //    var imageElement = document.createElement("img");
    //    imageElement.src = edit18;
    //    imageElement.title = "Edit Trip";
    //    element.appendChild(imageElement);
    //    return element;
    //}

    setDeleteMessage(tripCode: any) {
        this.setState({ DeleteParams: tripCode });
        if (tripCode.data.TripStatusCd == 'P') {
            //setTimeout(() => {
            this.setState({ DeleteMessage: 'Do you want to delete the trip?' });
            // }, 50);
        } else {
            //setTimeout(() => {
            this.setState({ DeleteMessage: 'Do you want to cancel the trip?' });
            // }, 50);
        }
    }

    fromDateOnChange(date) {
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.SFrmDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        this.setState({ Filters: searchTripParameters });
    }

    toDateOnChange(date) {
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.SToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        this.setState({ Filters: searchTripParameters });
    }

    TripNameOnChange(event: any): void {
        var Value: string = event.currentTarget.value;
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.TripName = Value;
        this.setState({ Filters: searchTripParameters });
    }

    OriginGeofenceOnChange(event: any): void {
        var Value: string = event.currentTarget.value;
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.SourceGofenceAddress = Value;
        this.setState({ Filters: searchTripParameters });
    }

    DestinationGeofenceOnChange(event: any): void {
        var Value: string = event.currentTarget.value;
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.DestGofenceAddress = Value;
        this.setState({ Filters: searchTripParameters });
    }

    TripDefinationchange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value;
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.TripDefId = Value;
        this.setState({ Filters: searchTripParameters });
    }

    TripStatuschange(event: React.FormEvent<HTMLSelectElement>) {
        var Value: string = event.currentTarget.value;
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.TripStatusDsc = Value;
        this.setState({ Filters: searchTripParameters });
    }

    handleSubmit(): void {
        var fromDttm = this.state.Filters.SFrmDate;
        var toDttm = this.state.Filters.SToDate;

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm))) {
            PopupWindow.showErrorMessage("TripStatus", "Departure Date should not be greater than Arrival Date.");
            return;
        }
        if (fromDttm != "Invalid date" && fromDttm != null && fromDttm != "")
            this.state.Filters.SFrmDate = DateFormat(new Date(fromDttm), 'mm/dd/yyyy HH:MM');
        if (toDttm != "Invalid date" && toDttm != null && toDttm != "")
            this.state.Filters.SToDate = DateFormat(new Date(toDttm), 'mm/dd/yyyy HH:MM');
        //if (fromDttm.toString() > toDttm.toString() ) {
        //    PopupWindow.showErrorMessage("TripStatus", "Departure Date should not be greater than Arrival Date.");
        //    return;
        //}
        //else if (fromDttm.toString() == "Invalid date" || fromDttm.toString() == null || fromDttm.toString()=="") {
        //    PopupWindow.showErrorMessage("TripStatus", "Invalid From Date.");
        //    return;
        //}
        //else if (toDttm.toString() == "Invalid date" || toDttm.toString() == null || toDttm.toString() == "") {
        //    PopupWindow.showErrorMessage("TripStatus", "Invalid To Date.");
        //    return;
        //}
        //else{
        var filterParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/GetTripStatusSearchData', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.SearchTripDetails_Result[]>)
            .then(data => {
                this.setState({ RowData: data });
                self.state.gridApiParams.paginationGoToFirstPage();
            });
        //}
    }

    //ValidateHistoryDates() {
    //    var fromDttm = this.state.Filters.SFrmDate;
    //    var toDttm = this.state.Filters.SToDate;
    //    if (fromDttm.toString() == "Invalid date" || fromDttm == null || fromDttm.toString() == "")
    //        return "Invalid From Date.";

    //    if (toDttm.toString() == "Invalid date" || toDttm == null || toDttm.toString() == "")
    //        return "Invalid To Date.";

    //    return "";
    //}
    handleClear(): void {
        var searchTripParameters: server.SearchTripParameters = JSON.parse(JSON.stringify(this.state.Filters));
        searchTripParameters.TripName = "";
        var modifiedDttm = DateFormat(new Date(Date.now()), 'mm/dd/yyyy');
        var fromDate = moment(new Date(modifiedDttm)).startOf('day').toString();
        var toDate = moment(new Date(modifiedDttm)).endOf('day').toString();
        searchTripParameters.SFrmDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        searchTripParameters.SToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        searchTripParameters.DestGofenceAddress = "";
        searchTripParameters.SourceGofenceAddress = "";
        searchTripParameters.TripDefId = "-1";
        searchTripParameters.TripStatusDsc = "-1";
        this.setState({ Filters: searchTripParameters });
    }

    closeModel() {
        $('#deleteModal').hide();
        $('#TripStatus').css('opacity', 1);
    }

    refreshTripGrid() {

        this.GetTripsData(this.state.SelectedOption, this.state.SelectedReefers);
        this.props.refreshStatusGrid();
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
    }

    performYesAction() {
        deleteYes = true;
        var updatedDeleteEvent = deleteEvent;
        this.setState({ DeleteYes: true });
        var par = this.state.DeleteParams;
        this.updateTripStatus(updatedDeleteEvent);
        //par.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
        //par.api.setRowData(par.api.gridOptionsWrapper.gridOptions.rowData);     
        this.closeModel();
    }

    updateTripStatus(params: any) {
        $('#globalLoader').show();
        var fCommends = this.setForwardCommandUnits();
        var deleteTripGeofencesDetails: server.DeleteTripParameters = JSON.parse(JSON.stringify(this.state.DeleteTripParameters));
        deleteTripGeofencesDetails.TripId = params.data.TripId;
        deleteTripGeofencesDetails.TripStatusDsc = params.data.TripStatusDsc;
        deleteTripGeofencesDetails.CommandUnits = fCommends;
        this.setState({ DeleteTripParameters: deleteTripGeofencesDetails });
        var deletetripGeofencesDetails: server.DeleteTripParameters = JSON.parse(JSON.stringify(this.state.DeleteTripParameters));
        var url = Config.ApiBaseUrl + '/api/Trip/EditTripStatus';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(deleteTripGeofencesDetails), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                this.refreshTripGrid();
                $('#globalLoader').hide();
                PopupWindow.showErrorMessage("Delete Trip", data);
            });
    }

    performNoAction() {
        this.setState({ DeleteYes: false });
        this.closeModel();
    }

    ShowPending() {
        $('#ShowPending').addClass('active');
        $('#ShowAll').removeClass('active');
        $('#ShowSpecific').removeClass('active');
        this.setState({ SelectedOption: 'show' });
        this.GetTripsData("show", this.state.SelectedReefers);
        $("#displayShowSpecific").removeClass('trip_status_grid_200');
        $("#displayShowSpecific").addClass('trip_status_grid');
    }

    ShowAll() {
        $('#ShowPending').removeClass('active');
        $('#ShowAll').addClass('active');
        $('#ShowSpecific').removeClass('active');
        this.setState({ SelectedOption: 'showall' });
        this.GetTripsData("showall", this.state.SelectedReefers);
        $("#displayShowSpecific").removeClass('trip_status_grid_200');
        $("#displayShowSpecific").addClass('trip_status_grid');
    }

    public GetTripsData(tripType: any, reeferData: any): void {
        $('#tripLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/RefTripDefinitionLst')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTripDefinition[]>)
            .then(data => {
                this.setState({ refTripDefinition: data });
            });
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/RefTripStatus')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTripStatus[]>)
            .then(data => {
                this.setState({ refTripStatus: data });
            });
        this.state.Filters.UnitMasetrId = reeferData[0].UnitMasterID;
        this.state.Filters.TripDefId = "-1";
        this.state.Filters.TripName = null;
        var modifiedDttm = DateFormat(new Date(Date.now()), 'mm/dd/yyyy');
        var fromDate = moment(new Date(modifiedDttm)).startOf('day').toString();
        var toDate = moment(new Date(modifiedDttm)).endOf('day').toString();
        this.state.Filters.SFrmDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.SToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        this.state.Filters.TripStatusDsc = "-1";
        this.state.Filters.SearchType = tripType;
        this.state.Filters.SourceGofenceAddress = "";
        this.state.Filters.DestGofenceAddress = "";
        var filterParams = JSON.stringify(this.state.Filters);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/GetTripStatusSearchData', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.SearchTripDetails_Result[]>)
            .then(data => {
                this.setState({ RowData: data });
                self.state.gridApiParams.paginationGoToFirstPage();
                $('#tripLoader').hide();
            });
    }

    ShowSpecific() {
        $('#ShowPending').removeClass('active');
        $('#ShowAll').removeClass('active');
        $('#ShowSpecific').addClass('active');
        this.setState({ SelectedOption: 'showspecific' });
        this.GetTripsData("showspecific", this.state.SelectedReefers);
        $("#displayShowSpecific").removeClass('trip_status_grid');
        $("#displayShowSpecific").addClass('trip_status_grid_200');
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    HideGeofenceAndTrip(value) {

        if (value == 'Geofence') {
            $('#rdoTripDefination').hide();
            $('#rdoGeofence').show();
        }
        else if (value == 'TripDefiniton') {
            $('#rdoGeofence').hide();
            $('#rdoTripDefination').show();
        }
    }

    public render() {
        return (
            <div>
                {this.LoadTripDetailsData()}
            </div>
        );
    }


    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestionsFenceId: this.getFenceNameSuggestions(value)
        });
    };

    getFenceNameSuggestions(value) {
        var geofences = this.state.RefGeofences;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : geofences.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };

    onDestSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            destSuggestionsFenceId: this.getDestFenceNameSuggestions(value)
        });
    };

    getDestFenceNameSuggestions(value) {
        var geofences = this.state.RefGeofences;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : geofences.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestionsFenceId: []
        });
    };

    onDestSuggestionsClearRequested = () => {
        this.setState({
            destSuggestionsFenceId: []
        });
    };


    onChangeFenceId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SourceGofenceAddress = newValue;
        $('#geofenceID').addClass("fw-semibold");

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };

    onDestChangeFenceId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.DestGofenceAddress = newValue;
        $('#geofenceID').addClass("fw-semibold");

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };
    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }


    LoadTripDetailsData() {
        const { suggestionsFenceId } = this.state;
        const { destSuggestionsFenceId } = this.state;

        const FenceIdListinputProps = {
            id: 'Address',
            placeholder: 'Enter Origin Geofence',
            value: this.state.Filters.SourceGofenceAddress,
            onChange: this.onChangeFenceId.bind(this)
        };
        const DestFenceIdListinputProps = {
            id: 'Address',
            placeholder: 'Enter Destination Geofence',
            value: this.state.Filters.DestGofenceAddress,
            onChange: this.onDestChangeFenceId.bind(this)
        };
        var tripDefinitions = this.state.refTripDefinition;
        var TripDefinationOptions = tripDefinitions.map(function (trip) {
            return (
                <option key={trip.TripDefId} value={trip.TripDefId}>{trip.TripDefNm}</option>
            );
        });
        var tripStatus = this.state.refTripStatus;
        var TripStatusOptions = tripStatus.map(function (tripstatus) {
            return (
                <option key={tripstatus.TripStatusCd} value={tripstatus.TripStatusCd}>{tripstatus.TripStatusDsc}</option>
            );
        });
        const Specifichidden = this.state.SelectedOption === 'showspecific' ? '' : 'hidden';
        return (<div>
            <div id="tripLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="nav nav-underline" role="group" aria-label="..." id='Trip-Status-buttons'>
                            <div className="btn-group" role="group">
                                <button class="nav-link active" id="ShowPending" data-bs-toggle="tab" data-bs-target="#ShowPending" type="button" role="tab" onClick={this.ShowPending.bind(this)} > Show Pending/Active </button>
                               
                            </div>
                            <div className="btn-group" role="group">
                                <button class="nav-link" id="ShowAll" data-bs-toggle="tab" data-bs-target="#ShowAll" type="button" role="tab" onClick={this.ShowAll.bind(this)} > Show All </button>
                                
                            </div>
                            <div className="btn-group" role="group">
                                <button class="nav-link" id="ShowSpecific" data-bs-toggle="tab" data-bs-target="#ShowSpecific" type="button" role="tab" onClick={this.ShowSpecific.bind(this)} > Show Specific </button>
                               
                            </div>
                        </div>
                    </div>
                </div>
                <div className={Specifichidden}>
                    <div id="HideControls" className="collapse show">
                        <div className='modal-controls-container'>
                            <div className="row">
                                <div className="col-md-2 text-md-end pe-0 ">
                                    <span className='col-form-label'>Search By:</span>
                                </div>
                                <div className="col-md-10 col-lg-10 col-sm-9 col-xs-9">
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="inlineRadioOptions" id="inlineRadio1" value="option1" onClick={(e) => this.HideGeofenceAndTrip('TripDefiniton')} />
                                        <label class="form-check-label"> Trip Definiton </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" name="inlineRadioOptions" id="inlineRadio2" value="option2" onClick={(e) => this.HideGeofenceAndTrip('Geofence')} />
                                        <label class="form-check-label"> Geofence </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2" id='rdoTripDefination'>
                                <div className="col-md-2 text-md-end pe-0 ">
                                    <label className='col-form-label'>Trip Definition:</label>
                                </div>
                                <div className="col-md-10 col-lg-10 col-sm-9 col-xs-9">
                                    <select className="form-select" id="cBoxSeverityStates" name="TripDefinationSelectedValue" value={this.state.Filters.TripDefId} onChange={this.TripDefinationchange.bind(this)}>
                                        <option value="-1">Select Trip Definition...</option>
                                        {TripDefinationOptions}
                                    </select>

                                </div>
                            </div>


                            <div className="row mt-2" id='rdoGeofence'>
                                <div className="col-md-2 text-md-end pe-0 ">
                                    <label className='col-form-label'>Origin Geofence:</label>
                                </div>

                                <div className='col-md-4 col-lg-4 col-sm-4 col-xs-4'>

                                    <Autosuggest name="sourceAddress" id="sourceAddress"
                                        suggestions={suggestionsFenceId}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        getSuggestionValue={this.getSuggestionValue}
                                        renderSuggestion={this.renderSuggestion}
                                        inputProps={FenceIdListinputProps}
                                        highlightFirstSuggestion={true}
                                    />

                                </div>

                                <div className="col-md-2 text-md-end px-0 ">
                                    <label className='col-form-label'>Destination Geofence:</label>
                                </div>
                                <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4">

                                    <Autosuggest name="destinationAddress" id="destinationAddress"
                                        suggestions={destSuggestionsFenceId}
                                        onSuggestionsFetchRequested={this.onDestSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onDestSuggestionsClearRequested}
                                        getSuggestionValue={this.getSuggestionValue}
                                        renderSuggestion={this.renderSuggestion}
                                        inputProps={DestFenceIdListinputProps}
                                        highlightFirstSuggestion={true}
                                    />

                                </div>
                            </div>

                        </div>
                        <div className='modal-controls-container'>
                            <div className="row">
                                <div className="col-md-2 text-md-end pe-0 ">
                                    <label className='col-form-label'>Trip Name:</label>
                                </div>
                                <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4">
                                    <div className='input-group'>
                                        <input type="text" className="form-control" id="tripName" name="TripName" value={this.state.Filters.TripName} onChange={e => this.TripNameOnChange(e)} />
                                    </div>
                                </div>
                                <div className="col-md-2 text-md-end pe-0 ">
                                    <label className='col-form-label'>Trip Status:</label>
                                </div>
                                <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4">
                                   
                                        <select className="form-select" id="cBoxTripStatus" name="TripStatusSelectedValue" value={this.state.Filters.TripStatusDsc} onChange={this.TripStatuschange.bind(this)}>
                                            <option value="-1">Select Trip Status...</option>
                                            {TripStatusOptions}
                                        </select>
                                  
                                </div>

                            </div>
                            <div className="row mt-2">
                                <div className="col-md-2 text-md-end pe-0 ">
                                    <label className='col-form-label'>Departure:</label>
                                </div>
                                <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4">
                                    <DatePicker
		                                selected={new Date(this.state.Filters.SFrmDate)}		                                
		                                onChange={this.fromDateOnChange.bind(this)}
		                                timeInputLabel="Time:"
                                        showYearDropdown
                                        yearDropdownItemNumber={5}
		                                dateFormat="MM/dd/yyyy hh:mm aa"
		                                showTimeInput  
		                                className=""   
                                        id="EDDate"                       
	                                />
                                    
                                </div>

                                <div className="col-md-2 text-md-end pe-0 ">
                                    <label className='col-form-label'> Arrival:</label>
                                </div>
                                <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4">
                                    <DatePicker
		                                selected={new Date(this.state.Filters.SToDate)}
		                                onChange={this.toDateOnChange.bind(this)}
		                                timeInputLabel="Time:"
                                        showYearDropdown
                                        yearDropdownItemNumber={5}
		                                dateFormat="MM/dd/yyyy hh:mm aa"
		                                showTimeInput  
		                                className=""  
                                        id="ADate"                        
	                                />                                    
                                </div>

                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12">
                                <div className='float-end hstack gap-2'>
                                    <button type="button" className="btn btn-primary" onClick={() => this.handleClear()}>Clear</button>
                                    <button type="button" className="btn btn-primary" onClick={() => this.handleSubmit()} >Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <GridToolBarPopups refreshGrid={this.onRefreshData.bind(this)} gridData={this.state.RowData} colDefs={ExcelcolDefs} parentchild={"P"} formName={"TripStatus"} />
                <div id='trip-pagesize'>
                    <div className="ag-theme-fresh trip_status_grid" id='displayShowSpecific'>
                        <AgGridReact
                            columnDefs={colDefs}
                            rowData={this.state.RowData}
                            onGridReady={this.onGridReady}
                            pagination={true}
                            accentedSort={true}
                            paginationPageSize={this.state.pageSize}>
                        </AgGridReact>
                    </div>
                    <div className='pageSize'>
                        <span className='pageSize-lable'>Page Size:</span>
                        <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>
                </div>
            </div>
            <div>
                <EditTrip refreshTripGrid={this.refreshTripGrid.bind(this)} refData={this.state.TripGeofencesDetails} />
            </div>
            <div>
                <div className="modal" role="dialog" id="deleteModal">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Trip Details</h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={this.closeModel.bind(this)}><span aria-hidden="true">&times;</span></button>

                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="alert alert-info" role="alert">
                                            <span className="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
                                            <div className="alert-text">
                                                {this.state.DeleteMessage}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => this.performYesAction()}  >Yes</button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.performNoAction()} >No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}